import type { MultiLineChartPoint } from "@/shared/charts";
export { getTotalPopulationTrendQueryRange } from "@/features/deployment-dashboard/shared/analytics-query-range";
import type { PopulationTrendAnalyticsPoint } from "@/features/deployment-dashboard/widgets/charts/population-trend-analytics/types";

export const AVERAGE_TOTAL_POPULATION_SERIES_ID = "average-total-population";
export const PEAK_TOTAL_POPULATION_SERIES_ID = "peak-total-population";
export const AVERAGE_DUTY_FREE_POPULATION_SERIES_ID = "average-duty-free-population";
export const PEAK_DUTY_FREE_POPULATION_SERIES_ID = "peak-duty-free-population";

export type PopulationTrendMetric = "total" | "duty-free";

export function getPopulationTrendAnalyticsErrorMessage(
  error: Error | string | null | undefined
): string | null {
  if (error == null) return null;
  return typeof error === "string" ? error : error.message;
}

export function mapPopulationTrendAnalyticsToMultiLineChartData(
  data: PopulationTrendAnalyticsPoint[],
  metric: PopulationTrendMetric = "total"
): MultiLineChartPoint[] {
  return data.map((point) => ({
    x: point.period,
    timestamp: point.timestamp,
    values: {
      [metric === "total"
        ? AVERAGE_TOTAL_POPULATION_SERIES_ID
        : AVERAGE_DUTY_FREE_POPULATION_SERIES_ID]:
        metric === "total"
          ? point.averageTotalPopulation
          : (point.averageDutyFreePopulation ?? null),
      [metric === "total" ? PEAK_TOTAL_POPULATION_SERIES_ID : PEAK_DUTY_FREE_POPULATION_SERIES_ID]:
        metric === "total" ? point.peakTotalPopulation : (point.peakDutyFreePopulation ?? null),
    },
  }));
}

export function deriveDutyFreePopulationTrend(
  totalData: PopulationTrendAnalyticsPoint[],
  trackedData: readonly { window_start: string; population: number }[]
): PopulationTrendAnalyticsPoint[] {
  const trackedByTimestamp = new Map(
    trackedData.map((point) => [point.window_start, point.population])
  );
  return totalData.map((point) => {
    const trackedPopulation = trackedByTimestamp.get(point.timestamp);
    return {
      ...point,
      averageDutyFreePopulation:
        point.averageTotalPopulation == null || trackedPopulation == null
          ? null
          : Math.max(0, point.averageTotalPopulation - trackedPopulation),
      peakDutyFreePopulation:
        point.peakTotalPopulation == null || trackedPopulation == null
          ? null
          : Math.max(0, point.peakTotalPopulation - trackedPopulation),
    };
  });
}
